// 詢問 openAI 問題
window.askOpenAI = function (message, needSetQuestion = true, callback) {
    let url = $('meta[name="send-response-message"]').attr("content");
    let threadId = $('meta[name="thread-id"]').attr("content");
    let chatId = $('meta[name="chat-id"]').attr("content");
    let useVoice = $('meta[name="use-voice"]').attr("content");
    let voiceLang = $('meta[name="voice-lang"]').attr("content");
    let agent_id = $('meta[name="chat-user-id"]').attr("content");

    if (needSetQuestion) {
        setQuestionContent(message);
    }

    $.ajax({
        url: url,
        method: "POST",
        data: {
            agent_id: agent_id,
            chat_id: chatId,
            message: message,
            thread_id: threadId,
            use_voice: useVoice,
            voice_lang: voiceLang,
        },
        success: function (data) {
            callback(removeHtmlTags(data.did_content), function () {
                setAnswerContent(data.reply, data.history_id);
            });

            $("#rd-price").html(data.price);
        },
        error: function (xhr, status, error) {
            console.error(
                "There has been a problem with your fetch operation:",
                error,
            );
        },
    });

    $('meta[name="use-voice"]').attr("content", 0);
};

// 取得 GPT 的回答
window.getMessage = function (historyId, callback) {
    let url = $('meta[name="get-answer"]').attr("content");
    let gptmodel = $('meta[name="gpt-model"]').attr("content");
    let threadId = $('meta[name="thread-id"]').attr("content");

    $.ajax({
        url: url,
        method: "POST",
        data: {
            history_id: historyId,
            thread_id: threadId,
            gpt_model: gptmodel,
        },
        success: function (data) {
            callback(removeHtmlTags(data.reply));
            $("#rd-price").html(data.price);
            setAnswerContent(data.reply, data.history_id);
        },
        error: function (xhr, status, error) {
            console.error(
                "There has been a problem with your fetch operation:",
                error,
            );
        },
    });
};

// 移除 HTML Tags
window.removeHtmlTags = function (str) {
    return str.replace(/<\/?[^>]+(>|$)/g, "");
};

// 設定問題
window.setQuestionContent = function (content, needLoading = true) {
    $("#rd-input-text").text(""); // 清空內容

    $("#rd-card").hide(); // 隱藏元素
    $("#rd-hello").hide(); // 隱藏元素

    $("#msgHistory").append(`
        <div class="right-item">${content}</div>
    `);

    if (needLoading) {
        $("#msgHistory").append(`
            <div class="left-item rd-loading-content">
                <div class="did-loading">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                </div>
            </div>
        `);
    }

    scrollQuestion();
};

// 設定答案
window.setAnswerContent = function (content, id) {
    $("#msgHistory").append(`
        <div class="left-item">
            ${content}
            <div class="comment-tool">
                <div class="good rd-click-review" data-id="${id}" data-type="2"></div>
                <div class="none-good rd-click-review" data-id="${id}" data-type="3"></div>
            </div>
        </div>
    `);

    $("#msgHistory").find("a").attr("target", "_blank").data("id", id);

    $(".rd-loading-content").hide();
    scrollQuestion();
    reviewEvent();
    trackEvent();
};

window.scrollQuestion = function () {
    gsap.to("#rd-did-content", {
        duration: 1,
        scrollTo: {
            y: $("#msgHistory").find(".right-item").last(),
            offsetY: 0,
        },
    });
};

function reviewEvent() {
    $(".rd-click-review")
        .unbind()
        .on("click", function () {
            let _this = $(this);
            let type = _this.data("type");
            let history_id = _this.data("id");

            $.ajax({
                method: "POST",
                url: $('meta[name="review"]').attr("content"),
                data: { history_id: history_id, type: type },
                cache: false,
                success: function (data, textStatus, jqXHR) {
                    _this
                        .closest(".comment-tool")
                        .find(".rd-click-review")
                        .removeClass("now");
                    _this.addClass("now");
                },
                error: function (e) {},
            });
        });
}

function trackEvent() {
    $("#msgHistory")
        .find("a")
        .unbind()
        .on("click", function () {
            let _this = $(this);
            let history_id = _this.data("id");
            let link = $(this).attr("href");

            $.ajax({
                method: "POST",
                url: $('meta[name="track"]').attr("content"),
                data: { history_id: history_id, link: link },
                cache: false,
            });
        });
}
